import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';
import { isDisabled } from 'app/infrastructure/data/date';

export const normalizeSequence = (externalUrls?: ExternalUrlItem[]): ExternalUrlItem[] => {

  return [...(externalUrls || [])]
    .sort((item1, item2) => (item1.sequence ?? 0) === (item2.sequence ?? 0)
      ? (isDisabled(item1.disabled) ? 1 : 0) - (isDisabled(item2.disabled) ? 1 : 0)
      : (item1.sequence ?? 0) - (item2.sequence ?? 0))
    .map((item, index) => item.sequence === index + 1
      ? item
      : {
        ...item,
        sequence: index + 1
      }
    );
};
